/* eslint-disable */
// @ts-nocheck

/* eslint-disable @typescript-eslint/no-unused-vars */
import { sum } from 'lodash'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'

import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline'

import useServerArea from '../../../../api/useServerArea'
import useServer from '../../../../api/useServerMain'
import useServerProduct from '../../../../api/useServerProducts'
import Select from '../../../../components/forms/Select'
/* eslint-disable react-hooks/exhaustive-deps */
import Button from '../../../../components/misc/Button'
import Modal from '../../../../components/misc/GenericModal'
import GenericTable, {
  DataTableInterface,
} from '../../../../components/misc/GenericTable'
import { BtnActions } from '../../../../components/misc/MultipleActBtn'
import ScrollTypeFilter from '../../../../components/misc/ScrollTypeFilter'
import SearchComponent from '../../../../components/misc/SearchComponent'
import { SelectInterface } from '../../../../interfaces/InterfacesLocal'
import {
  PriceInvoiceInterface,
  ProductInterface,
} from '../../../../interfaces/ServerInterfaces'
import { useAppSelector } from '../../../../store/hooks'
import {
  exchangeCurrency,
  formatCurrency,
  mathOperation,
  truncateValue,
} from '../../../../utils/helpers'
import { translateMeasure } from '../../../../utils/translate'
import { RegisterContext } from '../AllRegistersList'
import { EditContextBilling } from '../registerDetailsTabs/RegisterDetailsTab'
import { NewProductBillingModal3 } from './productsBillingStepModals/NewProductBillingModalV3'
import { UpdateProductBillingModal } from './productsBillingStepModals/UpdateProductBillingModal'

interface ProductFieldInterface {
  quantity: number
  product: ProductInterface | any
  price: { price: number; codeCurrency: string }
  measure: string
  allowQuantity: number
  observations?: string
}

// =====> MAIN SECTION
export const ProductsDetailsBillingStep = ({
  controlPrice,
  onSubmitForm,
}: any) => {
  // Hooks
  const { areas: allAreas } = useAppSelector((state) => state.nomenclator)

  const {
    setCurrentStep,
    isLoading: isLoadingContext,
    fields,
    remove,
    currentStep,
    setValue,
    control,
    watch,
    append,
    isSubmit,
    setOpenPayModal,
    isFetching,
    getValues,
  } = useContext(RegisterContext)
  const {
    editMode,
    defaultValues,
    delProductToAddArray,
    addProductsToDelArray,
  } = useContext(EditContextBilling)
  const { getProductsByArea, stockProducts, isLoading } = useServerArea()
  const { getAllProducts, allProducts } = useServerProduct()
  const [loadingHelper, setLoadingHelper] = useState(false)
  const type = watch!('registerType')
  const areaStockId = getValues!('areaStockId')

  // ------------ Get availableCurrencies at redux --->

  const { business } = useAppSelector((state) => state.init)

  const online_shop_area_stock = business?.configurationsKey.find(
    (item) => item.key === 'online_shop_area_stock'
  )?.value

  const currenciesSelector =
    business?.availableCurrencies.map((itm) => ({
      id: itm.code,
      name: itm.code,
    })) ?? []

  const { salesCategories } = useAppSelector((state) => state.nomenclator)
  const categoriesDisplay: SelectInterface[] = []
  salesCategories.map((item) => {
    categoriesDisplay.push({ id: item.id, name: item.name })
  })

  // EDIT MODE PRODUCTLIST ==============
  const stockAreaId = allAreas?.find(
    (area) =>
      area?.id === (defaultValues?.areaSales?.id ?? defaultValues?.areaId)
  )?.stockAreaId
  const [filter, setFilter] = useState<Record<
    string,
    string | number | boolean | null
  > | null>(null)
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      notStrickStock: type === 'PRE-BILLING',
    }))
  }, [type])

  const areaSalesId = watch!('areaSalesId') ?? defaultValues?.areaSales?.id
  const stockAreaIdToDisableSearch = allAreas?.find(
    (area) => area?.id === areaSalesId
  )?.stockAreaId
  const getAllDefaultProducts = async () => {
    const defaultProds: ProductFieldInterface[] = []
    defaultValues?.selledProducts?.map((selledProd) => {
      const variationQuantity = stockProducts
        .find((stockProd) => stockProd.product.id === selledProd.productId)
        ?.variations.find(
          (variation) => variation.id === selledProd.variationId
        )?.quantity
      // const stoctProd = stockProducts.find(
      //   (item) => item.id === selledProd.productId
      // );
      // if (stoctProd) {
      //   defaultProds.push({
      //     quantity: selledProd?.quantity,
      //     allowQuantity:
      //       variationQuantity! - selledProd?.quantity ??
      //       stoctProd?.quantity - selledProd?.quantity,
      //     price: {
      //       price: selledProd?.priceUnitary?.amount,
      //       codeCurrency: selledProd?.priceUnitary?.codeCurrency,
      //     },
      //     observations: selledProd?.observations,
      //     measure: translateMeasure(stoctProd?.product?.measure),
      //     product: stoctProd?.product,
      //     ...(selledProd.variationId && {
      //       variationId: selledProd?.variationId,
      //     }),
      //     ...(selledProd.variationId && {
      //       variationName: selledProd?.variation?.name,
      //     }),
      //   });
      // } else {
      defaultProds.push({
        quantity: selledProd?.quantity,
        observations: selledProd?.observations,
        allowQuantity:
          variationQuantity! - selledProd?.quantity ||
          selledProd?.quantity - selledProd?.quantity,
        price: {
          price: selledProd?.priceUnitary?.amount,
          codeCurrency: selledProd?.priceUnitary?.codeCurrency,
        },
        measure: translateMeasure(selledProd?.measure),
        product: { name: selledProd.name, productId: selledProd.productId },
        ...(selledProd.variationId && {
          variationId: selledProd?.variationId,
        }),
        ...(selledProd.variationId && {
          variationName: selledProd?.variation?.name,
        }),
      })
      // }
    })
    if (fields?.length === 0 && defaultProds.length > 0) append!(defaultProds)
  }

  const deleteEditMode = (objectInField: any) => {
    for (const selledProd of defaultValues?.selledProducts || []) {
      if (
        selledProd.productId === objectInField?.product?.productId &&
        selledProd.priceUnitary?.amount === objectInField?.price?.price &&
        selledProd.priceUnitary?.codeCurrency ===
          objectInField?.price?.codeCurrency
      ) {
        addProductsToDelArray!(selledProd)
      } else {
        delProductToAddArray!(
          objectInField?.product?.id ?? objectInField?.product?.productId
        )
      }
    }
  }

  const originsOnline = ['marketplace', 'online', 'shop', 'shopapk']
  const isOrderOnline = originsOnline.includes(defaultValues?.origin!)

  const getProductsByAreaId = async () => {
    if (stockAreaId || online_shop_area_stock) {
      const areaGet = isOrderOnline
        ? Number(online_shop_area_stock)
        : stockAreaId
      await getProductsByArea(areaGet, { areaStockSelect: isOrderOnline })
    }
    // getAllProducts({ all_data: true });
  }
  const { allowRoles } = useServer()

  useEffect(() => {
    if (editMode) {
      getProductsByAreaId()
    }
  }, [])
  useEffect(() => {
    if (editMode) {
      getAllDefaultProducts()
    }
  }, [stockProducts, allProducts, defaultValues])

  // ====================================

  const { user } = useAppSelector((state) => state.init)
  const [addModal, setAddModal] = useState(false)

  const [updateModal, setUpdateModal] = useState<{
    id: number | string | null
    state: boolean
  }>({ id: null, state: false })

  const onSubmit = async () => {
    if (fields && fields?.length > 0) {
      setCurrentStep!(currentStep! + 1)
    } else {
      toast.warn('No puede realizar un registro sin agregar productos')
    }
  }

  // Data table
  const actions: BtnActions[] = [
    {
      title: 'Nuevo Producto',
      action: () => setAddModal(true),
      icon: <PlusIcon className="h-5" />,
    },
  ]

  const tableTitles = [
    'Producto',
    'Cantidad',
    // "Precio unitario",
    'Subtotal',
    '',
  ]

  // AREAS BY ROLES
  const areas: SelectInterface[] = useMemo(() => {
    const allSalesAreas = allAreas?.filter((area) => area.type === 'SALE')
    // AREAS FOR ADMINS
    if (allowRoles(['ADMIN'])) {
      const areasForAdmins = allSalesAreas.map((area) => ({
        id: area?.id ?? null,
        name: area?.name ?? '',
      }))
      return areasForAdmins ?? []
      //  AREAS FOR MANAGER AREA
    } else if (
      allowRoles([
        'MANAGER_AREA',
        'MANAGER_SALES',
        'MARKETING_SALES',
        'MANAGER_BILLING',
      ])
    ) {
      const allowedAreasForManagerArea = user?.allowedSalesAreas.map(
        (area) => ({ id: area?.id, name: area?.name })
      )
      const areasForManagerArea = allSalesAreas
        ?.filter((area) =>
          allowedAreasForManagerArea?.find(
            (allowedArea) => allowedArea.id === area.id
          )
        )
        ?.map((area) => ({ id: area?.id ?? null, name: area?.name ?? '' }))
      return areasForManagerArea ?? []
    }
    return []
  }, [])

  //@ts-ignore
  const { tableData, priceUpdate, rowTotal } = useMemo(() => {
    const currency = watch!('transform_selled_products')
    const changeCurrency = !!currency
    const getPrice = (price: any): { amount: number; codeCurrency: string } => {
      if (changeCurrency) {
        const result = exchangeCurrency(
          { amount: price.amount, codeCurrency: price.codeCurrency },
          currency,
          [...(business?.availableCurrencies || [])]
          // allCurrencies
        )
        // Use proper rounding to 2 decimals to keep parity with payment flow
        const roundedAmount =
          Math.round(((result?.amount || 0) + Number.EPSILON) * 100) / 100
        return {
          amount: roundedAmount,
          codeCurrency: result?.codeCurrency ?? '',
        }
      }
      return price
    }

    const priceUpdate: { amount: number; codeCurrency: string }[] = []

    //----------------Display date table ------------------- --->
    const tableData: DataTableInterface[] =
      fields?.map((item: any, idx: number) => {
        const currentFieldId = fields?.findIndex(
          (field) => field.id === item.id
        )

        const priceSale = getPrice({
          amount: item?.price?.price,
          codeCurrency: item?.price?.codeCurrency,
        })

        const totalPriceSale = getPrice({
          amount: item?.price?.price,
          codeCurrency: item?.price?.codeCurrency,
        })

        priceUpdate[idx] = priceSale
        // setValue!(`products[${idx}].price.amount`, priceSale.amount);
        // setValue!(`products[${idx}].price.codeCurrency`, priceSale.codeCurrency);

        const productEdit = defaultValues?.selledProducts.find((ele) => {
          return (
            ele.productId === (item?.product?.productId || item?.product?.id) &&
            ele?.priceUnitary?.amount === item.price?.price &&
            ele?.priceUnitary?.codeCurrency === item.price?.codeCurrency
          )
        })

        const rowColor = editMode
          ? getColorRow(item.quantity, productEdit?.quantity)
          : ''

        return {
          rowId: item.id,
          rowColor,
          payload: {
            Producto: (
              <span className="flex flex-col">
                <p className="font-semibold">
                  {item?.variationId
                    ? `${item?.product?.name} ${item?.variationName}`
                    : item?.product?.name}
                </p>
                {item?.observations && (
                  <p className="text-slate-500 opacity-80">
                    {item?.observations}
                  </p>
                )}
              </span>
            ),
            Cantidad: (
              <>
                {item?.quantity} {item?.measure}
              </>
            ),
            // "Precio unitario": (
            //   <>
            //     {truncateValue(priceSale.amount, 2)} {priceSale.codeCurrency}
            //   </>
            // ),
            Subtotal: (
              <>
                {formatCurrency(
                  Math.round(
                    (totalPriceSale.amount * item.quantity + Number.EPSILON) *
                      100
                  ) / 100,
                  totalPriceSale.codeCurrency
                )}
              </>
            ),
            '': (
              <div className="grid min-w-max grid-cols-2 gap-4">
                {allowRoles(['ADMIN', 'MANAGER_AREA']) && (
                  <Button
                    action={() =>
                      setUpdateModal({ id: currentFieldId, state: true })
                    }
                    color="yellow-300"
                    icon={<PencilIcon className="h-4 text-yellow-500" />}
                    outline
                  />
                )}

                <Button
                  action={() => {
                    remove!(currentFieldId)
                    editMode && deleteEditMode!(fields[currentFieldId])
                  }}
                  color="red-500"
                  icon={<TrashIcon className="h-4 text-red-500" />}
                  outline
                />
              </div>
            ),
          },
        }
      }) ?? []
    //----------------Display date table ------------------- --->

    //---------------------Total a pagar vista previo ---------------- --->
    const rowTotals: {
      name: string
      amount: string | PriceInvoiceInterface | PriceInvoiceInterface[]
      color?: string
      prefix?: string
    }[] = []

    const subtotal: { amount: number; codeCurrency: string }[] = []

    fields?.forEach((prod) => {
      const priceSale = getPrice({
        amount: prod?.price?.price,
        codeCurrency: prod?.price?.codeCurrency,
      })
      //--- Control for shell in dif currency --->
      const found = subtotal.find((elem) =>
        changeCurrency
          ? priceSale.codeCurrency
          : elem.codeCurrency === prod.price.codeCurrency
      )
      if (found) {
        const subtotal = mathOperation(
          priceSale.amount,
          prod.quantity,
          'multiplication'
        )
        found.amount = mathOperation(found.amount, subtotal, 'addition', 2)
      } else {
        subtotal.push({
          amount: mathOperation(
            priceSale.amount,
            prod.quantity,
            'multiplication'
          ),
          codeCurrency: priceSale.codeCurrency,
        })
      }
    })

    rowTotals.push({
      name: `Total a pagar`,
      amount:
        subtotal?.map((itm) => ({
          amount: itm?.amount,
          codeCurrency: itm?.codeCurrency,
        })) ?? [],
    })

    const rowTotal: any = {
      rowId: 'totals',
      payload: {
        Producto: 'Totales:',
        Cantidad: `${sum(fields?.map((item) => Number(item.quantity)))}`,
        'Precio unitario': (
          <div className="flex flex-col gap-y-1">
            {rowTotals.map((title, idx) => {
              if (Array.isArray(title.amount)) {
                return title.amount.map((_, ix) => (
                  <div className="h-4 p-0 text-right font-semibold" key={ix}>
                    {ix === 0 ? title?.name : ''}
                  </div>
                ))
              } else {
                return (
                  <p className="h-4 p-0 text-right font-semibold" key={idx}>
                    {title?.name}
                  </p>
                )
              }
            })}
          </div>
        ),
        Subtotal: (
          <div className="flex flex-col gap-y-1">
            {rowTotals.map((item, idx) => {
              if (Array.isArray(item.amount)) {
                return item.amount.map((elem, ix) => (
                  <div
                    className={`${
                      item.color ?? ''
                    } flex flex-col items-start justify-start`}
                  >
                    <div className="h-4 p-0 text-left font-semibold" key={ix}>
                      {item?.prefix ?? ''}
                      {formatCurrency(elem.amount, elem.codeCurrency)}
                    </div>
                  </div>
                ))
              } else if (typeof item.amount === 'string') {
                return (
                  <p
                    className={`${
                      item.color ?? ''
                    } h-4 p-0 text-left font-semibold`}
                    key={idx}
                  >
                    {item.amount}
                  </p>
                )
              } else {
                return (
                  <p
                    className={`${
                      item.color ?? ''
                    } h-4 p-0 text-left font-semibold`}
                    key={idx}
                  >
                    {formatCurrency(
                      item.amount.amount,
                      item.amount.codeCurrency
                    )}
                  </p>
                )
              }
            })}
          </div>
        ),
      },
    }
    //---------------------Total a pagar vista previo ---------------- --->
    return { tableData, priceUpdate, rowTotal }
  }, [fields, remove, watch!('transform_selled_products')])

  // change total a pagar aproximado
  useEffect(() => {
    tableData.length !== 0 && tableData.push(rowTotal)
  }, [tableData, rowTotal, fields])

  //control de precio in transform_selled_products
  useEffect(() => {
    controlPrice && controlPrice(priceUpdate)
  }, [priceUpdate])

  useEffect(() => {
    if (fields?.length === 0) {
      setValue!('transform_selled_products', null)
    }
  }, [fields])

  const isAreaSelected = watch!('areaSalesId') ?? defaultValues?.areaSales?.id

  useEffect(() => {
    if (isAreaSelected && !editMode) {
      setAddModal(true)
    }
  }, [isAreaSelected])

  const transform_invoice_into_sell_currency =
    business?.configurationsKey.find(
      (item) => item.key === 'transform_invoice_into_sell_currency'
    )?.value === 'true'

  const transform_sell_currency =
    !editMode && transform_invoice_into_sell_currency

  const stockAreas = useMemo(() => {
    const stockAreas: SelectInterface[] = []
    allAreas.map((area) => {
      if (area.type === 'STOCK') {
        stockAreas.push({
          id: area?.id ?? null,
          name: area?.name ?? '',
        })
      }
    })

    return stockAreas
  }, [])

  return (
    <div className="flex min-h-[25rem] flex-col px-5">
      <div className="flex h-full flex-col justify-between">
        {/*PUNTO DE VENTA */}
        <div>
          <div
            className={`w-full col-span-${transform_sell_currency ? '2' : '3'}`}
          >
            {!editMode && (
              <Select
                control={control}
                data={areas ?? []}
                defaultValue={
                  defaultValues?.areaSales?.id
                    ? defaultValues?.areaSales?.id
                    : areas.length === 1
                      ? areas[0].id
                      : null
                }
                disabled={fields!.length > 0 && !isOrderOnline}
                label={'Punto de venta (*)'}
                name="areaSalesId"
                rules={{ required: 'Este campo es requerido' }}
              />
            )}
          </div>
          {transform_sell_currency && (
            <div className="w-full">
              <Select
                control={control}
                data={currenciesSelector}
                disabled={fields!.length === 0}
                label={'Facturar en'}
                name="transform_selled_products"
                placeholder="Seleccione una moneda"
              />
            </div>
          )}
        </div>
        <ScrollTypeFilter
          allButtonDisabled
          allButtonEnd
          className="my-0"
          current={Number(filter?.salesCategoryId) ?? null}
          items={categoriesDisplay}
          onChange={(item: string | number | null) =>
            setFilter({
              ...filter,
              salesCategoryId: item,
            })
          }
          scrollbarDisabled={true}
          title="Categorías de ventas"
        />

        <SearchComponent
          disabled={!stockAreaIdToDisableSearch && !areaStockId}
          findAction={(e: any) => setFilter({ search: e })}
          placeholder={
            !stockAreaIdToDisableSearch && !areaStockId
              ? 'Seleccione un punto de venta para continuar'
              : 'Buscar producto'
          }
        />

        <section className="grid w-full gap-x-5 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
          <div className="h-full max-h-[50dvh]">
            <NewProductBillingModal3 filter={filter} setFilter={setFilter} />
          </div>
          <div className="mb-10 mt-5 h-[50dvh]">
            <GenericTable
              //genericTableHeigth96
              classRowVoid="h-[50vh] overflow-hidden scrollbar-none"
              loading={editMode ? isLoading : false}
              maxTableHeight={'50dvh'}
              notShadowBotton={tableData.length === 0}
              tableData={tableData}
              tableTitles={tableTitles}
            />
          </div>
        </section>

        <div className="row-span-2 flex w-full items-end justify-end">
          {/*EDIT MODE BUTTONS  */}
          {!editMode && (
            <div className="flex w-full gap-3 pt-2">
              <Button
                action={() => {
                  setCurrentStep!(currentStep! - 1)
                }}
                color="white"
                disabled={currentStep === 0 ? true : false}
                full
                name="Atrás"
                outline
                textColor="blue-800"
                type="button"
              />
              {!watch!('shippingType') ? (
                <Button
                  action={onSubmitForm}
                  color={
                    watch!('registerType') === 'PRE-BILLING'
                      ? 'slate-700'
                      : 'white'
                  }
                  disabled={isSubmit}
                  full
                  loading={isSubmit}
                  name={'Registrar'}
                  outline={watch!('registerType') !== 'PRE-BILLING'}
                  textColor={
                    watch!('registerType') === 'PRE-BILLING'
                      ? undefined
                      : 'blue-800'
                  }
                  type={'submit'}
                />
              ) : (
                <Button
                  action={onSubmit}
                  color={'slate-700'}
                  disabled={isSubmit}
                  full
                  loading={isSubmit}
                  name={'Continuar'}
                  type={'button'}
                />
              )}

              {watch!('registerType') !== 'PRE-BILLING' &&
                !watch!('shippingType') && (
                  <Button
                    action={() => {
                      //Action para abrir el modal de pago directa,mente
                      setOpenPayModal && setOpenPayModal(true)
                      setLoadingHelper(true)
                      onSubmitForm && onSubmitForm(true)
                    }}
                    color="slate-700"
                    disabled={isSubmit}
                    full
                    loading={isSubmit && loadingHelper}
                    name="Registrar y facturar"
                    type="submit"
                  />
                )}
            </div>
          )}
        </div>
        <>
          {editMode && (
            <>
              {(defaultValues?.isPreReceipt ||
                watch!('registerType') === 'PRE-BILLING') && (
                <div className="ml-[90%] grid max-w-[80px]">
                  <Button
                    color="slate-700"
                    disabled={isLoadingContext}
                    full
                    loading={isLoadingContext}
                    name={editMode ? 'Actualizar' : `Registrar`}
                    type="submit"
                  />
                </div>
              )}
              {!defaultValues?.isPreReceipt &&
                watch!('registerType') !== 'PRE-BILLING' && (
                  <div className="ml-[90%] mt-2 grid max-w-[80px]">
                    <Button
                      action={onSubmitForm}
                      color="slate-700"
                      disabled={isFetching}
                      full
                      loading={isFetching}
                      name={editMode ? 'Actualizar' : `Registrar`}
                      type="submit"
                    />
                  </div>
                  // <Button
                  //   name="Continuar"
                  //   color="indigo-700"
                  //   type="button"
                  //   action={() => onSubmit()}
                  // />
                )}
            </>
          )}
        </>
      </div>

      {updateModal.state && typeof updateModal.id === 'number' && (
        <Modal
          close={() => setUpdateModal({ state: false, id: null })}
          state={updateModal.state}
        >
          {
            <UpdateProductBillingModal
              closeUpdateModal={() =>
                setUpdateModal({ state: false, id: null })
              }
              currentProductFieldId={updateModal?.id}
            />
          }
        </Modal>
      )}
    </div>
  )
}

const getColorRow = (
  afterQuantity: number | undefined,
  beforeQuantity: number | undefined
) => {
  if (!afterQuantity || !beforeQuantity) {
    return ''
  }

  if (afterQuantity > beforeQuantity) {
    return 'green-100'
  } else if (afterQuantity < beforeQuantity) {
    return 'red-100'
  }

  return ''
}
